import React from 'react';
import { useDraggable } from '@dnd-kit/core';

const DraggableDeckCard = ({ card, index, from, onDragStart, setSelectedCard, setShowCardInfoModal, globalIsDragging }) => {
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id: `drag-${from}-${card.id}-${index}`, // Use both card ID and index for unique identification
    data: {
      card,
      from,
      index,
      cardId: card.id, // Unique card identifier for stable tracking
    },
  });

  // Call drag handlers when drag starts/ends
  React.useEffect(() => {
    if (isDragging) {
      if (onDragStart) {
        setTimeout(() => {
          onDragStart();
        }, 50);
      }
    }
    // Note: Panel closing is now handled centrally in the parent component
  }, [isDragging, onDragStart]);

  const handleTouchStart = (e) => {
    console.log('Touch start on deck card:', card.name, 'from:', from);
  };

  const handleTouchMove = (e) => {
    console.log('Touch move on deck card:', card.name);
  };

  const handleMouseDown = (e) => {
    console.log('Mouse down on deck card:', card.name, 'from:', from);
    // Prevent immediate panel closing on desktop
    e.stopPropagation();
  };

  return (
    <img
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      src={card.card_images?.[0]?.image_url || ''}
      alt={card.name}
      style={{ 
        width: '100%', 
        maxWidth: '80px',
        opacity: isDragging ? 0.5 : 1,
        transform: transform ? `translate3d(${transform.x || 0}px, ${transform.y || 0}px, 0) scale(1.05) rotate(5deg)` : 'scale(1)',
        zIndex: isDragging ? 9999 : 'auto',
        cursor: 'grab',
        touchAction: 'none',
      }}
      onClick={(e) => {
        e.stopPropagation();
        // Only show card info modal if not dragging
        if (!isDragging && setSelectedCard && setShowCardInfoModal) {
          setSelectedCard(card);
          setShowCardInfoModal(true);
        }
      }}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onMouseDown={handleMouseDown}
      onContextMenu={(e) => e.preventDefault()}
    />
  );
};

export default DraggableDeckCard; 